/* TODO check how to apply dynamic styles using primeng pt/dt */
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { getColor } from '../../helpers/theme-utils/colors';
import { getFontWeight, getRem } from '../../helpers/theme-utils/spacing';

@Injectable({
  providedIn: 'root',
})
export class CategoryStylesService {
  private renderer: Renderer2;
  private styleElements: Map<string, HTMLStyleElement> = new Map();

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setGradientStyles(key: string, gradients: { [key: string]: string }): void {
    this.removeStyles(key);

    const styles = this.generateGradientStyles(gradients);

    const styleElement = this.renderer.createElement('style');
    this.renderer.setAttribute(styleElement, 'id', `dynamic-styles-${key}`);
    const textNode = this.renderer.createText(styles);
    this.renderer.appendChild(styleElement, textNode);

    this.renderer.appendChild(document.head, styleElement);

    this.styleElements.set(key, styleElement);
  }

  cleanup(key: string): void {
    this.removeStyles(key);
  }

  private generateGradientStyles(gradients: { [key: string]: string }): string {
    return Object.entries(gradients)
      .map(([category, color]) => {
        const className = this.getSafeClassName(category);
        const textColor = this.getContrastingTextColor(color);

        return `
          .category-${className} {
            background-color: ${color};
            border: ${getRem(2)} solid ${getColor('UiWhite')};
            border-radius: ${getRem(20)};
            box-shadow: 0 0 ${getRem(2)} ${getRem(1)} ${getColor('Sandstone90')};
            padding: ${getRem(6)} ${getRem(12)};
            color: ${textColor} !important;
            font-weight: ${getFontWeight('bold')};
          }
          .category-${className}.clickable-cell {
            cursor: pointer;
          }
          .category-${className}.clickable-cell:hover {
            box-shadow: 0 ${getRem(1)} ${getRem(12)} 0 ${getColor('Sandstone60')};
            cursor: pointer;
          }
        `;
      })
      .join('\n');
  }

  private getContrastingTextColor(backgroundColor: string): string {
    const hex = backgroundColor.replace('#', '');

    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    return yiq < 128 ? getColor('UiWhite') : getColor('UiBlack');
  }

  private removeStyles(key: string): void {
    const existingElement = this.styleElements.get(key);

    if (existingElement && existingElement.parentNode) {
      this.renderer.removeChild(document.head, existingElement);
      this.styleElements.delete(key);
    }
  }

  private getSafeClassName(name: string): string {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}
